module.exports = __webpack_public_path__ + "img/logoN.25bde6ff.png";